import { Grid } from "@mui/material";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AxiosResponse } from "axios";
import { useCallback, useState } from "react";

import {
  FormArray,
  FormInput,
  ISelectType,
  useFormContext,
} from "@4uhub/lib4uhub";
import FormTextEditor from "../../../../../components/UI/TextEditor/FormTextEditor";
import SiteLoginContentLanguage from "./SiteLoginContentLanguage";
import { TSiteLoginContentForm } from "./SiteLoginContentSchema";

const translationPath = "page.4uSiteApp.siteLoginContent.";

interface ISiteLoginContentLanguagesProps {
  service: (params?: any) => Promise<AxiosResponse<ISelectType[]>>;
}

const SiteLoginContentLanguages: React.FC<ISiteLoginContentLanguagesProps> = ({
  service,
}) => {
  const { control, formState } = useFormContext<TSiteLoginContentForm>();
  const { t } = useTranslation();
  const [defaultLang, setDefaultLang] = useState<ISelectType>();

  const languagesFieldArray = useFieldArray<TSiteLoginContentForm>({
    control,
    name: "siteLoginContentLanguages",
  });

  const loadDefaultLang = useCallback((lang: ISelectType) => {
    setDefaultLang(lang);
  }, []);

  return (
    <Grid item xs={12}>
      <FormArray
        title={t(translationPath + "document")}
        name="siteLoginContentLanguages"
        showAddButton={!defaultLang ? false : true}
        errorMessage={formState.errors?.siteLoginContentLanguages?.message}
        addButtonLabel={
          t(translationPath + "add_new_language") || "Add new language"
        }
        formArray={languagesFieldArray}
        appendValue={{
          language: defaultLang ? defaultLang : null,
          documentText: "",
          linkLabel: "",
        }}
        fieldsObject={(index) => {
          const language = `siteLoginContentLanguages.${index}.language`;
          const documentText = `siteLoginContentLanguages.${index}.documentText`;
          const linkLabel = `siteLoginContentLanguages.${index}.linkLabel`;

          return (
            <>
              <SiteLoginContentLanguage
                index={index}
                name={language}
                service={service}
                loadDefaultLang={loadDefaultLang}
              />
              <Grid item xs={12} sm={6}>
                <FormInput
                  size="small"
                  name={linkLabel}
                  label={t(translationPath + "link_label") || "Link label"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormTextEditor name={documentText} />
              </Grid>
            </>
          );
        }}
      />
    </Grid>
  );
};

export default SiteLoginContentLanguages;
